import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';
import JobProApi from '../../dependencies/JobProApi';

// Action types
const NAMESPACE = 'jobpro.scheduler/organization';
const FETCH_ORGANIZATION = `${NAMESPACE}/FETCH_ORGANIZATION`;
const FETCH_ORGANIZATION_COMPLETE = `${NAMESPACE}/FETCH_ORGANIZATION_COMPLETE`;

// Default state
const DEFAULT_STATE = {
  latitude: -80.871266,
  longitude: 35.439251
};

// Reducer
export default function (state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case FETCH_ORGANIZATION_COMPLETE:
      return {
        ...state,
        name: payload.name,
        latitude: payload.latitude || state.latitude,
        longitude: payload.longitude || state.longitude
      };
    default:
      return state;
  }
}

// Action creators
export const fetchOrganization = () => ({
  type: FETCH_ORGANIZATION
});

const fetchOrganizationComplete = organization => ({
  type: FETCH_ORGANIZATION_COMPLETE,
  payload: organization
});

// Epics
export const epic = action$ => action$.pipe(
  ofType(FETCH_ORGANIZATION),
  switchMap(() => JobProApi.currentUser.organization.get({
    fields: 'id,latitude,longitude,name'
  })),
  map(fetchOrganizationComplete),
);
